import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { BrokenLink } from '@portal-core/reports/models/broken-link.model';

@CollectionStateSelectors({
  stateType: ProjectReportBrokenLinksState
})
@State<ProjectReportBrokenLinksState>({
  name: ProjectReportBrokenLinksState.source
})
@Service({ autoProvided: false })
export class ProjectReportBrokenLinksState extends CollectionStateBase {
  static override source = 'ProjectReportBrokenLinks';
  getSource(): string {
    return ProjectReportBrokenLinksState.source;
  }
}

@Service()
export class ProjectReportsBrokenLinksDataService extends CollectionDataServiceBase<BrokenLink> {
  protected readonly stateType = ProjectReportBrokenLinksState;
}
